var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('JqxButton',{ref:"confirmEDI",attrs:{"theme":'material',"width":120,"height":40,"textPosition":'center'},on:{"click":function($event){_vm.confirmEDIinAttesa()}}},[_vm._v("\n    Conferma EDI\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c63973b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/cruddetails/AttesaEdiDetails.vue
// module id = null
// module chunks = 